module.exports = __webpack_public_path__ + "img/jiang.d3d2718d.png";